import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import core from '@gin-betting/core';

import { checkIsCmsLink } from 'utils';

const {
    utils: { getBettingOptions },
} = core;

interface OwnProps {
    to: string | null;
    styleName?: string;
    className?: string;
    title?: string;
}

type Props = OwnProps;

const SmartLink: React.FC<Props> = ({ to, title, className, children }) => {
    const bettingOptions = getBettingOptions();

    const linkClassName = cn('__app-SmartLink-link', className);

    if (!to) return null;

    if (bettingOptions.url.pagePath || checkIsCmsLink(to)) {
        return (
            <a
                title={title}
                className={linkClassName}
                href={
                    window.location.origin +
                    (bettingOptions.url.bettingPath + to).replace('//', '/')
                }
            >
                {children}
            </a>
        );
    }

    return (
        <Link title={title} className={linkClassName} to={to}>
            {children}
        </Link>
    );
};

export default SmartLink;
